<template>
<div data-module="category-page-header">
  <div class="color-block"
    :style="colorBlockStyles"
  />
  <div class="component-layout">
    <h1>{{ data.title }}</h1>
    <p ref="burnerText"
    >{{ data.burner }}</p>
  </div>
</div>
</template>


<script>
/*
  Category Page Header module

  data record:
  {
    title: <string>
    content: <string>
  }
*/
// Lib
import Vue from 'vue';

// Constants
import { MaxBrowserWidth } from '@/app-constants';

// Mixins
import WorkMixin from './WorkMixin';

export default {

  name: 'category-page-header',

  props: ['data'],

  mixins: [WorkMixin],

  data() {
    return {
      burnerHeight: 0,
    };
  },

  computed: {

    colorBlockStyles() {
      const { burnerHeight, currentWidth: currentBrowserWidth, deviceType } = this;

      // calculate width
      let offset = 0;
      if (currentBrowserWidth > MaxBrowserWidth) {
        offset = (currentBrowserWidth - MaxBrowserWidth) * 0.5;
      }

      // calculate height
      // this is height of burner text plus some value to cover title
      let height = 0;
      switch (deviceType) {
        case 'desktop':
          height = burnerHeight + 128;
          break;
        case 'tablet':
          height = burnerHeight + 134;
          break;
        case 'mobile':
        default:
          height = 0;
          break;
      }

      const style = {
        height: `${height}px`,
        marginLeft: `-${offset}px`,
      };
      return style;
    },

  },

  methods: {

    measureLayout() {
      this.burnerHeight = this.getBurnerHeight();
    },

    getBurnerHeight() {
      const el = this.$refs.burnerText;
      return (el) ? el.clientHeight : 0;
    },
  },

  watch: {

    currentWidth(/* newVal, oldVal */) {
      Vue.nextTick(() => {
        this.measureLayout();
      });
    },

  },

  mounted() {
    this.measureLayout();
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';
@import '~@/styles/_typography.scss';

$width: $layout--optimal-desktop - (65*2);
$layout--percentage: $width / $layout--optimal-desktop * 100%;

[data-module="category-page-header"] {
  width: 100%;

  // media query props
  margin-top: rem(($height--nav-bar-mobile + 2) * 1px); // adjust for nav bar
  padding-bottom: rem(0px);

  @include ngMq($nbp--tablet, up) {
    margin-top: rem(($height--nav-bar-tablet + 10) * 1px);
    padding-bottom: rem(56px);
  }

  @include ngMq($nbp--desktop, up) {
    margin-top: rem(($height--nav-bar-desktop + 52) * 1px);
    padding-bottom: rem(30px);
  }

  .color-block {
    position: absolute;
    width: 100vw;
    // height is calculated above
    bottom: 0;
    background-color: $color--quaternary-midtone;
  }

  .component-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      margin: 0 rem($grid-column-tablet * 0.5 * 1px);
      margin-top: 0;
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      margin: 0;
      @include ngGrid('desktop');
    }


    h1 {
      grid-column: 1 / span 7;
      

      // media query props
      @include serif( $size: (65, 64, -0.14), $weight: 'bold');
      margin-top: rem(62px);

      @media (max-width: 415px) {
        font-size: 56px;
      }

      @include ngMq($nbp--mobile, up) {
        hyphens: manual;
      }
      
      @include ngMq($nbp--tablet, up) {
        @include serif( $size: (65, 64, -0.14), $weight: 'bold');
        margin-top: rem(52px);
        grid-column: 1 / span 7;
        hyphens: none;
      }

      @include ngMq($nbp--desktop, up) {
        @include serif( $size: (101, 97, -0.21), $weight: 'bold');
        margin-top: rem(62px);
      }
    }

    p {
      // media query props
      grid-column: 1 / -1;
      margin-top: rem(52px - $grid-gap-mobile - 18);
      margin-bottom: rem(40px);

      @include ngMq($nbp--tablet, up) {
        grid-column: 1 / span 7;
        margin-top: rem(44px - $grid-gap-tablet - 18);
        margin-bottom: rem(76px - (18 + 38));
      }

      @include ngMq($nbp--desktop, up) {
        grid-column: 1 / span 7;
        margin-top: rem(58px - $grid-gap-desktop - 26);
        margin-bottom: rem(76px - (18 + 38));
        margin-right: rem($grid-gap-desktop * -1px); // pull to right, column
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/modules/work/CategoryHeader.vue